import { Component, OnInit, TemplateRef } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { BsModalService } from "ngx-bootstrap/modal";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";

interface Group {
  name: string;
  selectedDetail?: string;
}

@Component({
  selector: "app-addproduct",
  templateUrl: "./addproduct.component.html",
  styleUrls: ["./addproduct.component.css"],
})
export class AddproductComponent implements OnInit {
  ProductGroupName = new FormControl("");
  myControl1 = new FormControl("");
  myControl2 = new FormControl("");
  myControl3 = new FormControl("");
  myControl4 = new FormControl("");

  options: string[] = [];
  ptype: string[] = [];
  brand: string[] = [];
  series: string[] = [];
  pro: string[] = [];
  productGroupHd: Observable<string[]>;
  ProductTypeNm: Observable<string[]>;
  Brand: Observable<string[]>;
  Series: Observable<string[]>;
  Pro: Observable<string[]>;

  groups: Group[] = [];
  registerForm: FormGroup;
  businessStream: any = [];
  dropdownSetting: any = {};
  detailStream: any = [];
  isFiltersRendered: boolean = false;
  businessCategory: any = [];
  businessCategoryList: any = [];
  productType: any = [];
  ProductTypeList: any = [];
  productBrand: any = [];
  ProductBrandList: any = [];
  productSeries: any = [];
  proType: any = [];
  ProductSeriesList: any = [];
  productGroup: any;
  ProductGroupList = [];
  dropdownSettings: any = {};
  dropdownList: any;
  selectedItems = [];
  ProductGroup = [];
  ProductType = [];
  ProductSeries = [];
  ProType = [];
  ProductBrand = [];
  ProductBrandName: any;
  ProductTypeName: any;
  ProductSeriesName: any;
  ItemCode: any;
  Description: any;
  IsVatAllow: any;
  VatRate: any;
  Type: any;
  isRender: boolean = false;
  submitted: boolean = false;
  multiClick: boolean = false;
  ProductHeader = [];
  popup: boolean = false;
  modalRef: any;
  id: any = 0;
  selectedBusiness: any = [{ id: 1, itemName: "Equipment" }];
  userRId: any;
  permission: any;
  vat: any = [];
  dropdownList6 = [];
  previousPersent: number = 0;
  disableValue: any = [];

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.productGroup = [];
    this.dropdownList = [];
    this.selectedItems = [];
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Product_Add != 1 && this.userRId != 1) {
      this.toastrService.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    this.dropdownSetting = {
      singleSelection: true,
      text: "Business Vertical",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSettings = {
      singleSelection: true,
      text: "Select Category",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownList6 = [
      { id: true, itemName: "Yes" },
      { id: false, itemName: "No" },
    ];

    this.registerForm = this.formBuilder.group({
      rows: this.formBuilder.array([]),
      ProductId: this.id,
      BusinessVertical: ["", Validators.required],
    });

    this.GetBusinessVertical();
  }

  NewSearchFun(ev, i, fcn: any) {
    let value1 = ev.target.value;
    if (fcn == 1) {
      this.productGroupHd = this.registerForm.controls["rows"]["controls"][i][
        "controls"
      ]["ProductGroupName"].valueChanges.pipe(
        startWith(""),
        map((value: string) => this._filter(value1 || ""))
      );
    }
    if (fcn == 2) {
      this.ProductTypeNm = this.registerForm.controls["rows"]["controls"][i][
        "controls"
      ]["ProductTypeName"].valueChanges.pipe(
        startWith(""),
        map((value: string) => this._filter1(value1 || ""))
      );
    }
    if (fcn == 3) {
      this.Brand = this.registerForm.controls["rows"]["controls"][i][
        "controls"
      ]["ProductBrandName"].valueChanges.pipe(
        startWith(""),
        map((value: string) => this._filter2(value1 || ""))
      );
    }
    if (fcn == 4) {
      this.Series = this.registerForm.controls["rows"]["controls"][i][
        "controls"
      ]["ProductSeriesName"].valueChanges.pipe(
        startWith(""),
        map((value: string) => this._filter3(value1 || ""))
      );
    }
    if (fcn == 5) {
      this.Pro = this.registerForm.controls["rows"]["controls"][i]["controls"][
        "Type"
      ].valueChanges.pipe(
        startWith(""),
        map((value: string) => this._filter4(value1 || ""))
      );
    }
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  private _filter1(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.ptype.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  private _filter2(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.brand.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  private _filter3(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.series.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  private _filter4(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.pro.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  GetBusinessVertical() {
    let data = {};
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        let businessStreamArray = res;
        this.businessStream = [];

        for (const item of businessStreamArray["Data"]) {
          this.businessStream.push({
            id: item["Id"],
            itemName: item["Name"],
          });
        }

        this.GetDetailsByBusiness(businessStreamArray["Data"][0]["Id"]);
      } else {
        this.businessStream = [];
      }
    });
  }

  selectedbusiness: string = "";
  selectedBusinessId: string = "";
  onBusinessSelect(item: any) {
    this.GetDetailsByBusiness(this.selectedBusiness[0].id);
    let rows = this.registerForm.get("rows") as FormArray;
    rows.clear();
    this.groups = [];
    this.productGroup = [];
  }

  confirmYes(item: any, template: TemplateRef<any>) {
    this.selectedbusiness = item.itemName;
    if (
      item.itemName == "Equipment" ||
      item.itemName == "HVAC" ||
      item.itemName == "MEP" ||
      item.itemName == "Spares" ||
      item.itemName == "Service" ||
      item.itemName == "Installation"
    ) {
      this.popup = true;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  GetDetailsByBusiness(verticalId: number) {
    this.options = [];
    this.ptype = [];
    this.brand = [];
    this.series = [];
    this.pro = [];
    let data = { BusinessVerticalId: verticalId };
    this.UserService.GetDetailsByBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        res["ProductGroup"].forEach((element) => {
          this.productGroup.push({
            id: element.ProductGroupId,
            itemName: element.Name,
          });
          this.options.push(element.Name);
        });

        res["ProductType"].forEach((element) => {
          this.productType.push({
            id: element.ProductTypeId,
            itemName: element.Name,
          });
          this.ptype.push(element.Name);
        });

        res["ProductBrand"].forEach((element) => {
          this.productBrand.push({
            id: element.BrandId,
            itemName: element.Name,
          });
          this.brand.push(element.Name);
        });

        res["ProductSeries"].forEach((element) => {
          this.productSeries.push({
            id: element.ProductSeriesId,
            itemName: element.Name,
          });
          this.series.push(element.Name);
        });

        res["ProType"].forEach((element) => {
          this.proType.push({
            id: element.ProTypeId,
            itemName: element.Name,
          });
          this.pro.push(element.Name);
        });

        res["BusinessCategory"].forEach((element) => {
          this.businessCategory.push({
            id: element.BusinessCategoryId,
            itemName: element.Name,
            toString: function () {
              return this.id;
            },
          });
        });

        this.ProductHeader = [];
        for (let key in res["ProductColumn"][0]) {
          if (key != "BusinessVerticalId" && key != "ProductColumnId" && key != "Status") {
            this.ProductHeader.push(res["ProductColumn"][0][key]);
          }
        }

        this.isFiltersRendered = true;

        let detailStreamArray = res;
        this.detailStream = [];
        for (const item of detailStreamArray["BusinessCategory"]) {
          this.detailStream.push({
            id: item["BusinessCategoryId"],
            itemName: item["Name"],
          });
        }

        this.isRender = true;
        this.Addrow();
      } else {
        this.detailStream = [];
      }
    });
  }

  selecteddetail: string = "";
  selectedDetailId: string = "";
  onDetailSelect(item: any) {
    this.selecteddetail = "";
    this.selectedDetailId = "";
  }

  selectedgroup: string = "";
  selectedGroupId: string = "";
  onGroupSelect(item: any) {
    alert(item);
    this.selectedgroup = "";
    this.selectedGroupId = "";
  }

  selectedseries: string = "";
  selectedSeriesId: string = "";
  onSeriesSelect(item: any) {
    this.selectedseries = "";
    this.selectedSeriesId = "";
  }

  selectedbrand: string = "";
  selectedBrandId: string = "";
  onBrandSelect(item: any) {
    this.selectedbrand = "";
    this.selectedBrandId = "";
  }

  selectedtype: string = "";
  selectedTypeId: string = "";
  onTypeSelect(item: any) {
    this.selectedtype = "";
    this.selectedTypeId = "";
  }

  selectedpro: string = "";
  selectedProId: string = "";
  onProSelect(item: any) {
    this.selectedpro = "";
    this.selectedProId = "";
  }

  onItemSelect(item: any) {}

  onSubmit() {
    let rows = this.registerForm.get("rows") as FormArray;
    if (this.registerForm.valid) {
      this.multiClick = true;
      for (let key in rows.controls) {
        this.registerForm["controls"]["rows"]["value"][key][
          "BusinessCategory"
        ] = this.groups[key][0]["id"];
      }
      let data = this.registerForm.value.rows;
      this.spinner.show();
      this.UserService.AddUpdateProject(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.toastrService.success(res["Msg"]);
            this.router.navigate(["/productmanagment/productlist"]);
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Data"][0]["Error"]);
          } else {
            this.toastrService.error(res["Message"]);
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }

  Addrow() {
    let rows = this.registerForm.get("rows") as FormArray;
    if (rows.length < 10) {
      this.vat[rows.length] = true;
      rows.push(
        this.formBuilder.group({
          ProductId: this.id,
          BusinessCategory: ["", Validators.required],
          BusinessVertical: this.selectedBusiness[0].id,
          ProductGroupName: ["", Validators.required],
          ProductTypeName: new FormControl("", [Validators.required]),
          ProductBrandName: [""],
          ProductSeriesName: [""],
          Type: ["", Validators.required],
          ItemCode: ["", Validators.required],
          Description: ["", Validators.required],
          IsVatAllow: [""],
          VatRate: [0, Validators.required],
        })
      );
      this.disableValue[rows.length - 1] = true;
    } else {
      this.toastrService.error("Maximum 10 rows are allowed at once");
    }
  }

  onDeleteRow(rowIndex) {
    let rows = this.registerForm.get("rows") as FormArray;
    if (rows.length > 1) {
      rows.removeAt(rowIndex);
    }
  }

  decline() {
    this.registerForm.get("BusinessVertical").setValue("");
    this.modalRef.hide();
  }

  decline1() {
    this.modalRef.hide();
  }

  onVatSelect(dis: any, i) {
    let disk = dis.target.value;
    if (disk == "true") {
      this.disableValue[i] = true;
    } else if (disk == "false") {
      let rows = this.registerForm.get("rows") as FormArray;
      let vatSet = rows.controls[i];
      vatSet.get("VatRate").setValue(0);
      this.disableValue[i] = false;
    }
  }

  vatR(event) {
    if (event.target.value > 100) {
      this.toastrService.error("Value can not be greater than 100");
    }
  }

  getPrice(index: any) {
    let rows = this.registerForm.get("rows") as FormArray;
    let Percent = rows.value[index]?.VatRate;
    if (Percent > 100) {
      Percent = this.previousPersent;
    }
    rows.controls[index].patchValue({
      VatRate: Percent,
    });
    this.previousPersent = Percent;
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }
}
